/**
 * External dependencies
 */
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { map,  compact, replace } from 'lodash';

/**
 * Internal dependencies
 */
import WidgetErrorBoundary from 'blocks/reports/base/error-boundary';
import { getReport, getEditedReport } from 'state/reports/selectors';

let _map = {};

const mapStateToProps = (state, { report, reportId, includeEdits }) => {
	report = !report ? (includeEdits ? getEditedReport(state, reportId) : getReport(state, reportId)) : report;
	let config = (report && report.config) || {};
	return {
		chartType: report && (report.chartType || report.chart_type),
		...config,
		name: report && report.name,
		report,
	};
};

// this is a REPORT FACTORY for the DASHBOARD REPORTS
//
export default class ReportFactory {
	static create = (configuration) => {
		const { template, reportId, includeEdits = false } = configuration;
		const normalizedType = replace(template, /[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

		// load a backup report if it fails to load
		const Component = lazy(() =>
			import('blocks/reports/' + normalizedType + '-report').catch((e) => import('blocks/reports/base/report')),
		);

		const ConnectedComponent = connect(mapStateToProps)(Component);

		return (
			<div
				id={configuration.id}
				key={configuration.id}
				style={{ height: '100%', width: '100%', position: 'relative' }}
			>
				<WidgetErrorBoundary>
					<Suspense fallback={<div></div>}>
						<ConnectedComponent {...configuration} reportId={reportId} includeEdits={includeEdits} />
					</Suspense>
				</WidgetErrorBoundary>
			</div>
		);
	};

	static createAllReports(layoutConfig) {
		return compact(
			map(layoutConfig, (reportConfig) => {
				// cache the reports so they dont blink
				if (_map[reportConfig.id]) {
					return _map[reportConfig.id];
				}

				try {
					let w = ReportFactory.create(reportConfig);
					_map[reportConfig.id] = w;
					return w;
				} catch (error) {
					return null;
				}
			}),
		);
	}
}
